export class WorkMiloModel {
  public id: number = null;
  public idWorkMilo: number = null;
  public miloCode: string = null;
  public title: string = null;
  public titleFr: string = null;
  public completeTitle: string = null;
  public mainTitle: string = null;
  public genre: string = null;
  public yearOfProduction: string = null;
  public isoCode: string = null;
  public idVersionMilo: number = null;
  public checked = false;
  public langueOri: string = null;
  public codeOrdre: string = null;
  public designation: string = null;
  public processus: string = null;
  public societe: string = null;
  public societeGestion: string = null;
  public sousCategorie: string = null;
  public statutProjet: string = null;
  public orderCode: string = null;
  public referenceCurrencyCode = null;
  public company: string = null;
  public managmentCompany: string = null;
  public category: string = null;
  public subCategory: string = null;
  public buLabel: string = null;
  public process: string = null;
  public valdiationDate: Date = null;
  public closingDate: Date = null;
  public technicalClosingDate: Date = null;
  public systemStatus: string = null;
  public quota: string = null;
  public genres: string = null;
  public languages: string = null;
  public versions: any = null;
  public idDivision: number = null;
  public codeSap: string = null;
  public percentage: number = null;
  public index: number;
  public uuid: string;

  constructor() {}

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }

  public fromJSONs(jsons) {
    const refs: WorkMiloModel[] = [];
    if (jsons) {
      jsons.forEach(json => {
        refs.push(new WorkMiloModel().fromJSON(json));
      });
    }
    return refs;
  }
}
